import BaseListPresenter from "../../../../../base/BaseListPresenter";
import { getHeader } from "./headers/ApEarningsHeader";
import {
  mergeHeaders,
  convertLabels,
} from "../../../Payroll/helper-payroll/HelperFunction";
import { isBackPayItem } from "../../../Payroll/helper-payroll/constants/payrollConstants";

class ApEarningsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  componentDidMount() {
    const { deductions, contributionType } = this.view.props.panelInfo;

    const args = {
      deductions,
      contributionType,
    };

    console.log("args", args);
    const [tableHeader, primarySubHdr, secondarySubHdr] = getHeader(args);
    const params = [tableHeader, primarySubHdr, secondarySubHdr];

    const mergedResult = mergeHeaders(...params);
    const convertedHeaders = convertLabels(mergedResult);

    const tableHeaders = {
      tableHeader,
      primarySubHdr,
      convertedHeaders,
    };

    console.log("convertedHeaders", convertedHeaders);
    console.log("mergedResult", mergedResult);
    this.init();
    this.getObjects();
    this.view.setState({ tableHeaders });
  }
  init() {
    console.log("SAMPLEEEEEE1233");
    const { employeeInfo, payrollIds, payrollPrinted, deductions } =
      this.view.props.panelInfo;
    const employeeId = employeeInfo?.id;

    console.log("PAYROLLL IDSSS", payrollIds);

    this.limit = 10;
    this.where = {
      payrollID: { $in: payrollIds },
      "employee.id": employeeId,
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    // const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      // skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const { employeeInfo, backPayIds } = this.view.props.panelInfo;
    const employeeId = employeeInfo?.id;

    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const [objects, backpay] = await Promise.all([
        this.findObjectUseCase.execute(collection, query),
        this.findObjectUseCase.execute("payroll_back_pay", {
          where: {
            payrollID: { $in: backPayIds },
            "employee.id": employeeId,
          },
        }),
      ]);

      console.log("BACKKKKK PAY", backpay);
      const tableObjects = this._getTableObjects(objects, backpay);
      console.log("TABLE OBJ", tableObjects);
      console.log("obj--1233", objects);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(tableObjects);
      this.view.setState({ isLoading: false });
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  _getTableObjects(objects, backpay) {
    console.log("OBJECT", objects);
    const result = [];

    for (let i = 0; i < objects.length; i++) {
      const obj = objects[i];
      let formattedObject = {
        id: obj.id,
        payrollPeriod: `${obj.startDate} - ${obj.endDate}`,
        payrollType: `${obj.payrollType} - ${obj.jobType} - ${obj.payItem}`,
        apRate: obj.payCode,
      };

      const cases = this._getCases(obj);

      if (cases.firstCase || cases.secondCase) {
        formattedObject.totalDaysDuty = obj?.totalDaysDuty;
        formattedObject.proratedApRate = obj?.proratedApRate;
        formattedObject.absencesLeaves = obj?.absencesLeavesCurrAss ?? 0;
        formattedObject.latesUtPerMinute = obj?.latesUTMinsCurrent;
        formattedObject.earnedCurrentAssignment = obj?.earnedCurrAssignment;
        formattedObject.airportAugmentationRate = obj?.airportAugRate;
        formattedObject.amountEarnedAirportAugmentation = obj?.earnedAirportAug;
        formattedObject.absencesLeaves2 = obj?.absencesLeavesAirportAss ?? 0;
        formattedObject.latesUtPerMinute2 = obj?.latesUTMinsAirportAug;
        formattedObject.earnedAirportDuties = obj?.earnedAirportDuties;
        formattedObject.excessAirportDuties = obj?.excessAirportDuty ?? 0;
        formattedObject.totalEarned = obj?.totalEarned;
        formattedObject.overpayment = obj?.overpayment;
        formattedObject.flagRaising = obj?.flagRaising;
        formattedObject.netEarned = obj?.netEarned;
        formattedObject.netAmount = obj?.netAmount;
      }

      this._parseKeyValueArrayToObject(formattedObject, obj.deductions);

      result.push(formattedObject);
    }

    if (Array.isArray(backpay)) {
      for (let i = 0; i < backpay.length; i++) {
        const obj = backpay[i];
        let formattedObject = {
          id: obj.id,
          payrollType: `${obj.payrollType} - ${obj.jobType} - ${obj.payItem}`,
          apRate: obj.apRate,
          payrollPeriod: Array.isArray(obj.netAmount)
            ? obj.netAmount.map((entry) => entry.split(" - ")[0].trim())
            : [],
        };

        const cases = this._getCases(obj);

        if (cases.thirdCase) {
          formattedObject.apRateForBackPay = obj.apRateForBackPay;
          formattedObject.totalDaysDuty = obj.totalDaysDuty;
          formattedObject.proratedApRate = obj.proratedApRate;
          formattedObject.absencesLeaves = obj.absPresentAss_2;
          formattedObject.latesUtPerMinute = obj.lateUTperMinutePresentAss_2;
          formattedObject.earnedCurrentAssignment = obj.earnedCurrentAssignment;
          formattedObject.airportAugmentationRate = obj.airportAugmentationRate;
          formattedObject.amountEarnedAirportAugmentation =
            obj.amountEarnedAirportAugmentation;
          formattedObject.absencesLeaves2 = obj.absAirportAss_2;
          formattedObject.latesUtPerMinute2 = obj.lateUTperMinuteAirportAss_2;
          formattedObject.earnedAirportDuties = obj.earnedAirportDuties;
          formattedObject.excessAirportDuties = obj.earnedAirportDuties;
          formattedObject.totalEarned = obj.totalEarned;
          formattedObject.overpayment = obj.overpayment;
          formattedObject.flagRaising = obj.flagRaising;
          formattedObject.netEarned = obj.netEarned;
          formattedObject.netAmount = obj.netAmount;
        } else if (cases.secondCase) {
        }
        this._parseKeyValueArrayToObject(formattedObject, obj.deductions);
        result.push(formattedObject);
      }
    }

    return result;
  }

  _getCases(obj) {
    return {
      firstCase:
        obj.payrollType === "Augmentation Pay" &&
        obj.payItem === "General Payroll",

      secondCase:
        obj.payrollType === "Augmentation Pay" && obj.payItem === "Newly-Hired",
      thirdCase:
        obj.payrollType === "Augmentation Pay" && isBackPayItem(obj.payItem),
    };
  }

  _parseKeyValueArrayToObject(target, array) {
    if (!Array.isArray(array)) return;

    array.forEach((entry) => {
      const [key, value] = entry.split(":").map((x) => x.trim());
      if (key && value !== undefined) {
        target[key] = isNaN(value) ? value : parseFloat(value);
      }
    });
  }
}
export default ApEarningsPresenter;
